module.exports = __webpack_public_path__ + "resources/img/logo_toast_m.80c4374efcb09f8712619ba490357cab.svg";